import { AVAILY_SCRIPT_URLS, Environment } from 'src/lib'

export const isLocalhost = window.location.hostname === 'localhost'

export const isLocalhostOrPreview = isLocalhost || window.location.hostname.includes('preview')

export const isStaging = () =>
  window.location.origin === AVAILY_SCRIPT_URLS.STAGING ||
  (window.env?.REACT_APP_ENV && window.env.REACT_APP_ENV === Environment.Staging)

export const isOnlineTerminPage = window.location.href.includes('online-termin')
